import { z } from 'zod';

/** Скільки лотів має сенс тримати поруч: більше не вміщається на екран без прокрутки. */
export const MAX_COMPARE = 4;

/**
 * Вибір для порівняння живе в URL — так його можна переслати колезі
 * або зберегти в закладках (§11 гайду).
 */
export const compareSearchSchema = z.object({
	ids: z
		.union([z.string(), z.array(z.string())])
		.transform((v) => (Array.isArray(v) ? v : [v]))
		.pipe(z.array(z.string().min(1)).max(MAX_COMPARE))
		.optional(),
});

export type CompareSearch = z.infer<typeof compareSearchSchema>;
